module.exports = __webpack_public_path__ + "img/info-validation-icon.f08a0c3b.svg";